import { StandardSvgProps } from 'src/components/svg/StandardSvgProps';
import { SDefaultSvg, SFilledPath } from 'src/components/svg/SvgStyles';
import styled from 'src/lib/styles/css';
import theme from "src/components/themes/DefaultTheme";

//#region [Props]
type FlagSvgProps = {
	selected?: boolean;
} & StandardSvgProps;
//#endregion

//#region [Component]
export default function FlagSvg({ className, selected = false }: FlagSvgProps) {
	return (<SFlagSvg className={className} width="18.041" height="22.949" viewBox="0 0 18.041 22.949">
		{!selected && <path d="M-1824,228.949v-16c0-.014,0-.027,0-.041V212a5.006,5.006,0,0,1,5-5h12.038a1,1,0,0,1,.91.581,1.009,1.009,0,0,1,.092.419,1,1,0,0,1-.238.649h0l-.017.021-4.938,5.479,4.446,4.933a1,1,0,0,1,.17,1.076,1,1,0,0,1-.913.593H-1819a4.975,4.975,0,0,1-3-1v9.2a1,1,0,0,1-1,1A1,1,0,0,1-1824,228.949Zm2-16.949v3.752a3,3,0,0,0,3,3h9.3l-3.544-3.933a1,1,0,0,1-.256-.67,1,1,0,0,1,.256-.67l4.038-4.481H-1819A3,3,0,0,0-1822,212Z" transform="translate(1824 -207)" />}
		{selected && <path d="M 2.9999998e-7,21.949 V 5.949 5.908 5 C 0.0033003,2.2399469 2.2399473,0.0033061 5,0 h 12.038 c 0.390803,-7.866e-4 0.746254,0.2261555 0.91,0.581 0.06035,0.1314577 0.09172,0.2743535 0.092,0.419 3.38e-4,0.237747 -0.08404,0.4678368 -0.238,0.649 v 0 l -0.017,0.021 -4.938,5.479 4.446,4.933 c 0.264194,0.293618 0.330806,0.715235 0.17,1.076 -0.160639,0.360522 -0.518308,0.592831 -0.913,0.593 H 5 c -1.082145,0.0018 -2.1353717,-0.349263 -2.9999997,-1 v 9.2 c 0,0.552285 -0.447715,1 -1,1 -0.553067,1e-6 -1.001106,-0.448934 -1.00000000000002,-1.002 z" />}
	</SFlagSvg>)
}
//#endregion

//#region [Styles]
const SFlagSvg = styled(SDefaultSvg)`
	path {
		fill: ${theme.palette.turkis2};
	}
`;
//#endregion